import { render } from "./GradingEvaluation.vue?vue&type=template&id=d8dcdf1c"
import script from "./GradingEvaluation.vue?vue&type=script&lang=js"
export * from "./GradingEvaluation.vue?vue&type=script&lang=js"

import "./GradingEvaluation.vue?vue&type=style&index=0&id=d8dcdf1c&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__